import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import MultiLevelSelect from '../../../../../../../../components/MultiLevelSelect'

import { selectedTikTokAdAccountSelector } from '../../../../../../../../modules/selectors/adAccounts'
import {
  tikTokInterestsIsLoadingSelector,
  tikTokInterestsSelector
} from '../../../../../../../../modules/selectors/tikTokConstants'
import { clearTikTokInterests, getTikTokInterests } from '../../../../../../../../modules/actions/tikTokConstants'

import { INTERESTS } from '../../../../../../../ReusableFormFields/InterestsFields/fields'

const TikTokInterestsMultiLevelSelect = ({ formik }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { setFieldValue, values } = formik

  const { id: selectedAdAccountId } = useSelector(selectedTikTokAdAccountSelector)
  const interests = useSelector(tikTokInterestsSelector)
  const interestsLoading = useSelector(tikTokInterestsIsLoadingSelector)

  useEffect(() => {
    dispatch(getTikTokInterests({ account: selectedAdAccountId, language: 'en', placement: ['PLACEMENT_TIKTOK'] }))

    return () => {
      dispatch(clearTikTokInterests())
    }
  }, [dispatch, selectedAdAccountId])

  return (
    <MultiLevelSelect
      title={t('Add an Interest')}
      setFieldValue={setFieldValue}
      value={values[INTERESTS]}
      name={INTERESTS}
      options={interests}
      isLoading={interestsLoading}
      placeholder={t('Select Interests')}
    />
  )
}

export default TikTokInterestsMultiLevelSelect
